import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * German Tax ID generator following Single Responsibility Principle
 */
export class DeGenerator extends BaseGenerator {
  generate() {
    let taxId;
    let attempts = 0;
    
    do {
      // Generate first 10 digits
      const digits = this.randomDigits(10);
      
      // Calculate check digit
      let product = 10;
      
      for (let i = 0; i < 10; i++) {
        let sum = (parseInt(digits[i]) + product) % 10;
        if (sum === 0) sum = 10;
        product = (sum * 2) % 11;
      }
      
      let checkDigit = 11 - product;
      if (checkDigit === 10) checkDigit = 0;
      
      taxId = digits + checkDigit;
      attempts++;
    } while (!this.isValidStructure(taxId) && attempts < 100);

    return taxId;
  }

  isValidStructure(taxId) {
    // German Tax ID has specific structure rules
    // This is a simplified check
    const digitCounts = {};
    for (let digit of taxId.substring(0, 10)) {
      digitCounts[digit] = (digitCounts[digit] || 0) + 1;
    }
    
    // No digit should appear more than 3 times
    for (let count of Object.values(digitCounts)) {
      if (count > 3) return false;
    }
    
    return true;
  }
}